import React, { useState } from "react";
import MenuModal from "../menu/MenuModal";
export default function AboutSection() {
    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <section className="aboutSection">
            <div className="container aboutGrid">
                <div className="aboutText">
                    <h2>Biz Kimiz?</h2>
                    <p>
                        Scald Coffee Patisserie olarak kahvenin ve tatlı sanatının insanları bir araya getiren en güzel detaylardan biri olduğuna inanıyoruz. İlk olarak Düzce Akçakoca’da açtığımız şubemizle yola çıktık ve kısa sürede misafirlerimizin ilgisiyle büyüyerek Akçakoca’daki ikinci şubemizi de hizmete açtık.


                    </p>
                    <p>Her fincan kahvede özenle seçilmiş çekirdekleri kullanıyor, her tatlıyı taze ve kaliteli malzemelerle hazırlıyoruz. Tatlılarımız, özel şeflerimizin yer aldığı kendi imalathanemizde günlük ve titizlikle hazırlanarak tüm şubelerimize ulaştırılmaktadır. Böylece her üründe aynı kaliteyi ve lezzeti korumayı hedefliyoruz.</p>
                    <p>
                        Markamızı büyütme yolculuğumuzda bir sonraki adımı ise İstanbul’un en özel semtlerinden biri olan Yeldeğirmeni’nde attık ve üçüncü şubemizi burada açarak Scald Coffee Patisserie deneyimini daha geniş bir kitleyle buluşturduk.



                    </p>
                    <p>Scald Coffee Patisserie; dostlukların kurulduğu, sohbetlerin uzadığı ve her ziyaretin keyifli bir deneyime dönüştüğü bir buluşma noktası olmayı hedefler. Misafirlerimize kaliteli hizmet, samimi bir ortam ve unutulmaz lezzetler sunmak için her gün aynı özenle çalışıyoruz.
                    </p>
                    <p>Sizi de Scald Coffee Patisserie’de kahvemizi ve tatlılarımızı keşfetmeye davet ediyoruz.</p>

                    <div className="aboutActions">
                        <button className="aboutMenu" onClick={() => setMenuOpen(true)} type="button">
                            Menüyü İncele
                        </button>
                        <a className="btnGhost" href="#contact">İletişim</a>
                    </div>
                </div>
            </div>
            {menuOpen && (
                <MenuModal open={menuOpen} onClose={() => setMenuOpen(false)} />
            )

            }
        </section>
    );
}